import { React, useEffect, useState } from "react";
import { TextField } from "@mui/material";

export const FiltroMensajeriaEnviada = ({
    filtros, setFiltros, onCargar
}) => {

    const toggleSeccion = (seccion) => {
        setFiltros(prev => ({
            ...prev,
            seccion: prev.seccion === seccion ? "" : seccion // si seleccionas la misma, deselecciona
        }));
    };


    const sucursalesCatalogo = {
        1: "NAVOLATO",
        2: "TEPIC",
        11: "CAIMANERO",
        12: "SAN JOSE",
        21: "ELDORADO",
        22: "SANTIAGO I.",
        31: "COSTA RICA",
        32: "TECUALA",
        41: "LA CRUZ",
        42: "LAS VARAS",
        51: "EL ROSARIO",
        52: "SAN VICENTE",
        61: "VILLA UNION"
    };

    return (
        <>
            <div className="mensajeria-filtro-container">
                <div className="mensajeria-filtro-header">
                    <div className="mensajeria-filtro-header-titulo">
                        Filtros
                    </div>
                </div>
                <div className="mensajeria-filtros-seccion">
                    <h4 className="mensajeria-filtros-titulo">
                        Periodo
                    </h4>
                    <div className="mensajeria-filtros-lista">
                        <TextField
                            type="date"
                            label="Fecha inicio"
                            InputLabelProps={{ shrink: true }}
                            sx={{ mt: 1 }}
                            inputProps={{ max: filtros.fechaFin || undefined }}
                            value={filtros.fechaInicio || ""}
                            onChange={(e) => {
                                const value = e.target.value;
                                setFiltros(prev => ({
                                    ...prev,
                                    fechaInicio: value,
                                    fechaFin: prev.fechaFin && value > prev.fechaFin ? value : prev.fechaFin
                                }));
                            }}
                        />

                        <TextField
                            type="date"
                            label="Fecha fin"
                            InputLabelProps={{ shrink: true }}
                            sx={{ mt: 1 }}
                            inputProps={{ min: filtros.fechaInicio || undefined }}
                            value={filtros.fechaFin || ""}
                            onChange={(e) => {
                                const value = e.target.value;
                                setFiltros(prev => ({
                                    ...prev,
                                    fechaFin: value
                                }));
                            }}
                        />
                    </div>
                </div>

                <div className="mensajeria-filtros-seccion">
                    <h4 className="mensajeria-filtros-titulo">
                        Sección
                    </h4>
                    <div className="mensajeria-filtros-lista">
                        <label className="mensajeria-filtro-item">
                            <input
                                type="checkbox"
                                checked={filtros.seccion.includes("CT")}
                                onChange={() => toggleSeccion("CT")}
                            />
                            Cotizaciones
                        </label>
                        <label className="mensajeria-filtro-item">
                            <input
                                type="checkbox"
                                checked={filtros.seccion.includes("GT")}
                                onChange={() => toggleSeccion("GT")}
                            />
                            Garantía Temprana
                        </label>
                        <label className="mensajeria-filtro-item">
                            <input
                                type="checkbox"
                                checked={filtros.seccion.includes("GD")}
                                onChange={() => toggleSeccion("GD")}
                            />
                            Garantias Tardias
                        </label>
                        <label className="mensajeria-filtro-item">
                            <input
                                type="checkbox"
                                checked={filtros.seccion.includes("CH")}
                                onChange={() => toggleSeccion("CH")}
                            />
                            Checklist
                        </label>
                        <label className="mensajeria-filtro-item">
                            <input
                                type="checkbox"
                                checked={filtros.seccion.includes("MT")}
                                onChange={() => toggleSeccion("MT")}
                            />
                            Mantenimiento
                        </label>
                        <label className="mensajeria-filtro-item">
                            <input
                                type="checkbox"
                                checked={filtros.seccion.includes("CV")}
                                onChange={() => toggleSeccion("CV")}
                            />
                            Cartera Vencida
                        </label>
                        <label className="mensajeria-filtro-item">
                            <input
                                type="checkbox"
                                checked={filtros.seccion.includes("CP")}
                                onChange={() => toggleSeccion("CP")}
                            />
                            Cartera por Vencer
                        </label>
                        <label className="mensajeria-filtro-item">
                            <input
                                type="checkbox"
                                checked={filtros.seccion.includes("PR")}
                                onChange={() => toggleSeccion("PR")}
                            />
                            Promoción de refacciones
                        </label>
                    </div>
                    <button
                    className="button-accept"
                        onClick={() => onCargar()}
                    >Cargar</button>
                </div>
            </div>
        </>
    )
}